import { createApp } from "vue";
import App from "./App.vue";
import "./index.css";
import { createMetaManager } from "vue-meta";
import i18n from "./i18n";

import FlagIcon from "vue-flag-icon";

createApp(App).use(i18n).use(FlagIcon).use(createMetaManager()).mount("#app");
